import { useQuery } from '@apollo/client';
import { GetSharedFolders } from 'gql/patients/__generated__/GetSharedFolders';
import { GET_SHARED_FOLDERS } from 'gql/patients/queries';
import { FC } from 'react';
import { Empty, List } from 'antd';
import { StyledListItemContent } from 'theme/styled';
import { round2Decimal } from '@medicusunion/front-utils';
import { PageHeader } from '@ant-design/pro-layout';
import { useSearchParams } from 'react-router-dom';

import FolderItem from './FolderItem';
import { Loading } from 'components/ui';
import FileItem from './FileItem';

interface IProps {
  folderId: string;
  patientId: string;
}

const FolderContent: FC<IProps> = ({ folderId, patientId }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { data, loading } = useQuery<GetSharedFolders>(GET_SHARED_FOLDERS, {
    variables: {
      query: {
        folder_id: folderId,
        patient_id: patientId
      }
    }
  });

  const folder = (data?.getSharedFolders.data || [])[0];
  const children = folder?.children || [];
  const files = folder?.files || [];

  const onBack = () => {
    const pageQuery = searchParams.get('page');
    const newPage = pageQuery?.replace(`/${folderId}`, '') as string;

    searchParams.set('page', newPage);
    setSearchParams(searchParams);
  };

  if (loading) {
    return <Loading />;
  }

  if (!folder) {
    return null;
  }

  return (
    <StyledListItemContent>
      <PageHeader
        style={{ marginBottom: 16 }}
        title={folder.name}
        onBack={onBack}
      />
      {!children.length && !files.length ? (
        <Empty />
      ) : (
        <>
          {!!children.length && (
            <List
              dataSource={children}
              renderItem={item => (
                <List.Item className="list-content-item">
                  <FolderItem
                    key={`folder-${item.id}`}
                    id={item.id}
                    name={item.name}
                  />
                </List.Item>
              )}
            />
          )}
          {!!files.length && (
            <List
              dataSource={files}
              renderItem={item => (
                <List.Item className="list-content-item">
                  <FileItem
                    key={`file-${item.id}`}
                    format={item.mime}
                    patientId={patientId}
                    size={round2Decimal((Number(item.size) || 0) / 1024 / 1024)}
                    name={item.name}
                  />
                </List.Item>
              )}
            />
          )}
        </>
      )}
    </StyledListItemContent>
  );
};

export default FolderContent;
